import styled from "styled-components/macro";
import { Radio } from "antd";
import { COLORS, WEIGHT } from "../../../../layout/theme";

export const Inner = styled.div`
	display: flex;
	flex-direction: column;
`;

export const Filters = styled.div`
	margin: 20px 0;

	& button {
		padding: 0 !important;
	}
`;

export const RadioOptions = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-top: 20px;
	margin-bottom: 20px;

	.ant-radio-group {
		display: flex;
		flex-wrap: wrap;
		gap: 8px;
	}

	.ant-btn {
		border-radius: 10px !important;
	}
`;

export const AntdRadioButton = styled(Radio.Button)`
	border: 1px solid #e5e7eb !important;
	border-radius: 10px !important;
	font-weight: ${WEIGHT.Bold};
	background: #ffffff !important;
	color: #6b7280 !important;
	box-shadow: none !important;

	&.ant-radio-button-wrapper-checked {
		background: #eef2ff !important;
		border-color: #c7d2fe !important;
		color: #3730a3 !important;
	}

	&:before {
		display: none !important;
	}
`;

export const ActionButton = styled.button`
	border: none;
	border-radius: 5px;
	background-color: transparent;
	padding: 5px;
	cursor: pointer;
	color: ${COLORS.Primary};

	&:hover {
		background-color: ${COLORS.Grey};
	}
`;

export const TableContainer = styled.div`
	.ant-table-thead > tr > th {
		background: ${COLORS.Primary};
	}

	.ant-table-thead
		> tr
		> th:not(:last-child):not(.ant-table-selection-column):not(
			.ant-table-row-expand-icon-cell
		):not([colspan])::before {
		background-color: ${COLORS.White};

		div {
			color: ${COLORS.White};
		}
	}

	thead {
		border-color: ${COLORS.White};
		border: 1px solid ${COLORS.White};
	}
`;

export const CompaginationDiv = styled.div`
	display: flex;
	gap: 4px;
`;

export const FilterContainer = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 16px;
	align-items: center;

	.ant-picker,
	.ant-select-selector {
		height: 40px !important;
		border-radius: 14px !important;
		border: 1px solid #cbd5e1 !important;
		box-shadow: none !important;
		font-size: 16px !important;
	}

	.ant-picker {
		padding: 0 16px !important;
	}

	.ant-select-selector {
		padding: 0 16px !important;
		display: flex !important;
		align-items: center !important;
	}

	.ant-select-selection-placeholder,
	.ant-select-selection-item {
		color: #334155 !important;
		font-size: 16px !important;
	}

	.ant-picker:hover,
	.ant-picker-focused,
	.ant-select-focused .ant-select-selector,
	.ant-select:hover .ant-select-selector {
		border-color: #4f46e5 !important;
		box-shadow: 0 0 0 2px rgba(79, 70, 229, 0.08) !important;
	}

	.ant-picker-range {
		min-width: 260px;
	}

	@media only screen and (max-width: 1200px) {
		.ant-picker-range,
		.ant-select {
			flex: 1 1 220px;
			min-width: 220px;
		}
	}

	@media only screen and (max-width: 768px) {
		.ant-picker-range,
		.ant-select,
		.ant-input-affix-wrapper {
			width: 100%;
			min-width: 100%;
		}
	}
`;

export const FilterSection = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
`;

export const FilterActions = styled.div`
	display: flex;
	gap: 12px;
	align-items: center;
	margin-left: auto;

	@media only screen and (max-width: 1200px) {
		margin-left: 0;
	}

	@media only screen and (max-width: 768px) {
		width: 100%;
		flex-direction: column;
	}
`;

export const FilterCard = styled.div`
	width: 100%;
	background: ${COLORS.White};
	border-radius: 20px;
	padding: 20px 28px;
	box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08);
`;
